import { useRef } from 'react'
import { Observable, fromEvent, of } from 'rxjs'
import { distinctUntilChanged, map, share, startWith, throttleTime } from 'rxjs/operators'

import { headerHeightPixels } from '../../brunswick/constants'
import { RefsContainer } from '../../brunswick/containers/refs'

export function useShowStickyAddToBag() {
  const { detailsSectionAddToBagSectionRef, footerRef } = RefsContainer.useContainer()

  const showStickyAddToBag$: Observable<boolean> = useRef(
    typeof window === 'undefined'
      ? of(false)
      : fromEvent(window, 'scroll').pipe(
          throttleTime(10),
          map<Event, boolean>(() => {
            if (!detailsSectionAddToBagSectionRef.current || !footerRef.current) return false
            const addToBagHasPassed: boolean =
              detailsSectionAddToBagSectionRef.current.getBoundingClientRect().bottom <
              headerHeightPixels
            const footerHasEntered: boolean =
              footerRef.current.getBoundingClientRect().top < window.innerHeight
            return addToBagHasPassed && !footerHasEntered
          }),
          startWith(false),
          distinctUntilChanged(),
          share()
        )
  ).current

  return showStickyAddToBag$
}
